import { render, staticRenderFns } from "./Biaobaiqiang.vue?vue&type=template&id=5b76257b&scoped=true&"
import script from "./Biaobaiqiang.vue?vue&type=script&lang=js&"
export * from "./Biaobaiqiang.vue?vue&type=script&lang=js&"
import style0 from "./Biaobaiqiang.vue?vue&type=style&index=0&id=5b76257b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b76257b",
  null
  
)

export default component.exports